import { type FC } from 'react';

export const WhySgTimeToMarketSpeedIcon: FC = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M8.33337 1.6665H11.6667"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 11.6665L12.5 9.1665"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33337 11.6667C3.33337 15.3461 6.32061 18.3333 10 18.3333C13.6795 18.3333 16.6667 15.3461 16.6667 11.6667C16.6667 7.98723 13.6795 5 10 5C6.32061 5 3.33337 7.98723 3.33337 11.6667V11.6667"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhySgTimeToMarketEfficiencyIcon: FC = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <defs>
      <clipPath id="clip_sg_time_to_market_efficiency">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip_sg_time_to_market_efficiency)">
      <path
        d="M8.33329 18.3333V5.83333C8.33329 5.3731 7.9602 5 7.49996 5H3.33329C2.41282 5 1.66663 5.74619 1.66663 6.66667V16.6667C1.66663 17.5871 2.41282 18.3333 3.33329 18.3333H13.3333C14.2538 18.3333 15 17.5871 15 16.6667V12.5C15 12.0398 14.6269 11.6667 14.1666 11.6667H1.66663"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 1.6665H17.5C17.9602 1.6665 18.3333 2.0396 18.3333 2.49984V7.49984C18.3333 7.96007 17.9602 8.33317 17.5 8.33317H12.5C12.0397 8.33317 11.6666 7.96007 11.6666 7.49984V2.49984C11.6666 2.0396 12.0397 1.6665 12.5 1.6665V1.6665"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const WhySgTimeToMarketTrendZigzagIcon: FC = () => (
  <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M4 20L11 13L17 17L23 9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M18 9H23V14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const WhySgTimeToMarketTimelineCheckIcon: FC = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M6 12L10.5 16.5L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
